import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from "react-i18next";

export const TreatmentAuthorization = () => {
  debugger
  const { t } = useTranslation();
  const [treatments, setTreatments] = useState([]);
  const [authStatusCounts, setAuthStatusCounts] = useState({});
  const [statusColors, setStatusColors] = useState({});
  const [loading, setLoading] = useState(true);
  const contract = useSelector((state) => state.userData);
  const token = localStorage.getItem("AccessToken");
  const navigate = useNavigate();
  const location = useLocation();
  const benefitsData = location.state?.Benifit;
  const userTypePremier = contract.userData.Premiere;
  const [treatmentAuthText, setTreatmentAuthText] = useState("");

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

const  [benefitData1,setBenefitData1] = useState({});


  useEffect(() => {
    const fetchTreatmentData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          Endpoints.LoadTreatmentStatus,
          {
            _params: JSON.stringify({
              MemberID: contract.userData.MemberID,
              Contract:
                contract.userData.Contract || contract.userData.ContractIdentified,
              DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
              EmailID: contract.userData.EmailID,
            }),
          },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = response.data || [];
        setTreatments(data);

        // Count occurrences of each AuthStatus and map its color
        const statusCounts = data.reduce(
          (counts, treatment) => {
            const status = treatment.AuthStatus || "Unknown";
            counts[status] = (counts[status] || 0) + 1;

            if (treatment.StatusColor) {
              counts.colors[status] = treatment.StatusColor.toLowerCase();
            }
            return counts;
          },
          { colors: {} }
        );

        setAuthStatusCounts(statusCounts);
        setStatusColors(statusCounts.colors);
      } catch (error) {
        console.error(t("errorfetchingtreatment"), error);
        setTreatments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTreatmentData();
  }, [contract.userData.MemberID, token]);

  useEffect(() => {
    const fetchBenefits = async () => {
      if (!contract.userData.EmailID) return; // Prevent unnecessary API calls if EmailID is missing

      const payload = {
        _Params: JSON.stringify({ EmailID: contract.userData.EmailID, MemberID: contract.userData.MemberID,DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal" }),
      };

      try {
        const response = await axios.post(Endpoints.UnderstandingBenefits, payload, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        });
        // Set visibility based on response data
          const benefitData = response?.data || {}; // Adjust based on your API response structure
      setBenefitData1(benefitData);
      if (benefitData.TreatmentAuthText) {
        debugger
        setTreatmentAuthText(benefitData.TreatmentAuthText);
      }


      } catch (error) {
        console.error("Error fetching benefits:", error);
      }
    };

    fetchBenefits();
  }, [contract.userData.EmailID, token]);

  const handleUploadDocumentsClick = () => {
    navigate("/treatment-upload-documents");
  };
  const handleRequestAuthorizationClick = () => {
    navigate("/verbal-authorization", {
        state: { ucReqAuth: benefitData1?.UCHealthAuth || "N/A" } // Passing ucReqAuth as state
      });
  };

const handleViewLetterClick = async (treatment) => {
  if (treatment.GenerateLetter === "Yes" && treatment.LetterPath) {
    let win = null;
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isAndroid = /Android/.test(ua); // Checking for Android

    // Open a blank window immediately to prevent Safari's pop-up blocker from blocking it
    if (isIOS ) {
      // Open a blank window immediately for iOS 
      win = window.open('', '_blank');
    } 

    try {
      // Log the API call and request data
      const response = await axios.post(
        Endpoints.LoadandConvertDocument,
        `_Params=${encodeURIComponent(
          JSON.stringify({
            MemberID: contract.userData.MemberID,
            PDF_Document: treatment.LetterPath,
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            EmailID: contract.userData.EmailID,
          })
        )}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Log the API response
      console.log("API Response:", response);

      if (response.data && response.data.Result === 1 && response.data.Data) {
        const url = response.data.Data;

        // If it's iOS/Android, set the URL in the window opened earlier
        if (win) {
          win.location = url; // Set location of the window after the async call
        } else {
          // For non-iOS devices, open the URL in a new tab
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      } else {
        console.log("Could not load document. Displaying error message.");
        // alert(t('couldnotloaddocument'));
        if (win) win.close();
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      // alert(t("errorloadingdocuments"));
      if (win) win.close();
    }
  }
};



  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  const handleBackClick = () => {
    if (benefitsData == "Benifit") {
      navigate("/benefits-landingpage");
    } else {
      navigate("/home");
    }
  };

  // Mapping of AuthStatus to class names
  const authStatusClassMap = {
    Accepted: "badge-success",
    Pending: "badge-warning",
    Denied: "badge-danger",
    Unknown: "badge-secondary",
  };

  return (
    <>
      {isHighmarkPortal ? (
        <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>
          <h2 className="page-heading">{t("treatmentauthheading")}</h2>
        </div>
      ) : (
        <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
              {t("Back")}
            </span>
          </button>
          <h2 className="page-heading">{t("treatmentauthheading")}</h2>
        </div>
      )}

      {treatments.length === 0 ? (
       <>
       <div className="col-md-6 mt-4 d-flex justify-content-end align-items-center">
         <button
           className="win-btn-primary-w-content mobile-view"
           onClick={handleUploadDocumentsClick}
         >
           {t("uploaddocumentsforreview")}
         </button>
       </div>
       <div className="col-md-12 mt-4">
         <p>
           Your current authorizations are listed below. Please note, an
           authorization request is required for all individual
           procedures/treatments.
         </p>
       </div>
     </>
      ) : (
        <>
          <div className="col-md-12 mt-0 d-flex justify-content-end align-items-center">
            {(benefitData1.MemberReqAuth === "Yes" || benefitData1.UCHealthAuth === "Yes" ) && (
              <button
                className="win-btn-primaryy-w-content mobile-view me-3"
                onClick={handleRequestAuthorizationClick}
              >
                {t("requestAuthorizationHeading")}
              </button>
            )}
            <button
              className="win-btn-primaryy-w-content mobile-view"
              onClick={handleUploadDocumentsClick}
            >
              {t("uploaddocumentsforreview")}
            </button>
          </div>
          <div className="col-md-12 mt-4">
            <p>
              Your current authorizations are listed below. Please note, an
              authorization request is required for all individual
              procedures/treatments.
            </p>
            <p>
              <em>
                {treatmentAuthText ||
                ""}
              </em>
            </p>
          </div>
          <div className="col-md-12 treatment-stats-wrapper">
            {Object.entries(authStatusCounts).map(([status, count]) => {
              if (status === "colors") return null;
              const authStatusClassMap = {
                Accepted: "legend-success", // Green
                Pending: "legend-warning", // Yellow
                Denied: "legend-danger",   // Red
                Unknown: "legend-secondary", // Gray
              };

              return (
                <div
                  key={status}
                  className={`treatment-stats-individual ${
                    authStatusClassMap[status] || "legend-secondary"
                  }`}
                >
                  {`${status} - ${count}`}
                </div>
              );
            })}
          </div>

          <div className="col-md-12 d-md-flex justify-content-between flex-wrap">
            {Array.isArray(treatments) &&
              treatments.map((treatment, index) => (
                <div key={index} className="treatment-auth-table-wrapper">
                  <table className="table treatment-auth-table">
                    <tbody>
                      <tr>
                        <td>{t("description")}</td>
                        <td>{treatment.CPTDesc || t("notavailable")}</td>
                      </tr>
                      <tr>
                        <td>{t("referenceno")}</td>
                        <td>{treatment.FormattedAuthNo || t("notavailable")}</td>
                      </tr>
                      { treatment.ProviderName && (<tr>
                        <td>{t("providername")}</td>
                        <td>{treatment.ProviderName}</td>
                      </tr>
                      )}
                      { treatment.NetworkStatus && (
                        <tr>
                        <td>{t("networkstatus")}</td>
                        <td>{treatment.NetworkStatus}</td>
                      </tr>
                      )}                      
                      <tr>
                        <td>{t("fromdate")}</td>
                        <td>{treatment.RequestFromdate || "Not Available"}</td>
                      </tr>
                      <tr>
                        <td>{t("todate")}</td>
                        <td>{treatment.RequestToDate || t("notavailable")}</td>
                      </tr>
                      {userTypePremier === "Yes" && (
                        <>
                          <tr>
                            <td>{t("estimatedtreatmentcost")}</td>
                            <td>
                              {treatment.EstimatedCost || t("notavailable")}
                            </td>
                          </tr>
                          <tr>
                            <td>{t("estimatedcostshare")}</td>
                            <td>
                              {treatment.EstimatedCostShare || t("notavailable")}
                            </td>
                          </tr>

                          <tr>
                            <td>{t("claimstatus")}</td>
                            <td>
                              {treatment.ClaimStatus || t("notavailable")}
                            </td>
                          </tr>
                        </>
                      )}
                      <tr>
                        <td>{t("authstatus")}</td>
                        <td>
                          <span
                            className={`badge ${
                              authStatusClassMap[treatment.AuthStatus] ||
                              "badge-secondary"
                            }`}
                          >
                            {treatment.AuthStatus}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>{t("generateletter")}</td>
                        <td>
                          {treatment.GenerateLetter === "Yes" &&
                          treatment.LetterPath ? (
                            <span
                              onClick={() => handleViewLetterClick(treatment)}
                              className="view-letter"
                            >
                              {t("viewletter")}
                            </span>
                          ) : (
                            "Not Available"
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))}
          </div>
        </>
      )}
    </>
  );
};

export default TreatmentAuthorization;